import _ from 'lodash';

export const FUNCTION_BRACKETS = ['(', ')'];

export const LEX_TOKEN_TYPES = {
  value: 'value',
  field: 'field',
  spec_field: 'spec_field',
  separator: 'separator',
  operator: 'operator',
  bracket: 'bracket',
  space: 'spaces',
  function: 'function',
  anySingleCharacter: 'anySingleCharacter',
  date: 'date',
  bool: 'bool',
  array: 'array',
  decimal: 'decimal',
};

export const ARRAY_FUNCTION_ENUM = {
  ANY: 'ANY',
  ALL: 'ALL',
  COUNT: 'COUNT',
  SUM: 'SUM',
  WHERE: 'WHERE',
  MAX_BY: 'MAX_BY',
  MIN_BY: 'MIN_BY',
  SELECT: 'SELECT',
  STRING_JOIN: 'STRING_JOIN',
};

export const ARRAY_FUNCTIONS = Object.values(ARRAY_FUNCTION_ENUM);

export const ARRAY_FUNCTIONS_WITH_ITERATORS = _.without(
  ARRAY_FUNCTIONS,
  ARRAY_FUNCTION_ENUM.STRING_JOIN,
);

const DATE_FUNCTION_ENUM = {
  ADD_DAYS: 'ADD_DAYS',
  ADD_HOURS: 'ADD_HOURS',
  ADD_MINUTES: 'ADD_MINUTES',
  ADD_MONTHS: 'ADD_MONTHS',
  ADD_SECONDS: 'ADD_SECONDS',
  ADD_YEARS: 'ADD_YEARS',
  DATE: 'DATE',
  DATE_NOW: 'DATE_NOW',
  GET_DATE: 'GET_DATE',
  GET_YEAR: 'GET_YEAR',
  ADD_BUSINESS_DAYS: 'ADD_BUSINESS_DAYS',
  FORMAT_DATE: 'FORMAT_DATE',
  CONVERT_DATE: 'CONVERT_DATE',
};

export const DATE_FUNCTIONS = Object.values(DATE_FUNCTION_ENUM);

const SPEC_FIELD_ARRAY_FUNCTIONS = [ARRAY_FUNCTION_ENUM.MAX_BY, ARRAY_FUNCTION_ENUM.MIN_BY];

export const REGEXP = {
  integer: '(?:[0-9]+)',
  double: '(?:(\\d+\\.\\d+))',
  date: "(?:\\'(19[0-9]{2}|20[0-9]{2})-(0[0-9]|1[0-2])-([0-2][0-9]|3[0-1])( (0[0-9]|1[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?)?\\')",
  spec_field: `(?:(${SPEC_FIELD_ARRAY_FUNCTIONS.join('|')})\\([\\s\\S]*?\\)\\.\\w+)`,
  field: '(?:([\\w\\.]+))',
  string: "(?:\\'(.*?)\\')",
  separator: '(?:,{1})',
  operator: '(?:&&|\\|\\||>=|<=|==|!=|[><]|contains|startsWith|endsWith|\\+|-|\\/|\\*)',
  bracket: '(?:[()]{1})',
  bool: '(?:(true|false))',
  space: '(?:\\s+)',
  anySingleCharacter: '(?:.{1})',
};

const ARITHMETICAL_OPERATORS = ['+', '-', '*', '/'];

export const OPERATORS = [
  '>=',
  '<=',
  '==',
  '!=',
  '>',
  '<',
  ...ARITHMETICAL_OPERATORS,
  'contains',
  'startsWith',
  'endsWith',
];

// Top-level infix boolean chaining (`a && b`, `a || b`) is NOT part of the
// CriteriaExpressionItem grammar — boolean composition is expressed via the
// AND(...) / OR(...) functions. These tokens are lexed (so they are never
// silently swallowed) and then rejected by the parser with a clear message.
export const LOGICAL_INFIX_OPERATORS = {
  '&&': 'AND',
  '||': 'OR',
};

export const getLogicalInfixOperatorError = operator =>
  `Use ${LOGICAL_INFIX_OPERATORS[operator]}(a, b) instead of "${operator}" to combine conditions`;

const BOOLEAN_FUNCTIONS_ENUM = {
  AND: 'AND',
  OR: 'OR',
  NOT: 'NOT',
  EMPTY: 'EMPTY',
};

export const BOOLEAN_FUNCTIONS = Object.values(BOOLEAN_FUNCTIONS_ENUM);

export const LOGIC_FUNCTIONS = [
  BOOLEAN_FUNCTIONS_ENUM.AND,
  BOOLEAN_FUNCTIONS_ENUM.OR,
  BOOLEAN_FUNCTIONS_ENUM.NOT,
];

const STRING_FUNCTIONS_ENUM = {
  CONCAT: 'CONCAT',
};

export const STRING_FUNCTIONS = Object.values(STRING_FUNCTIONS_ENUM);

export const SWITCH_FUNCTION_ENUM = {
  SWITCH: 'SWITCH',
  CASE: 'CASE',
};

export const SWITCH_FUNCTIONS = [SWITCH_FUNCTION_ENUM.SWITCH, SWITCH_FUNCTION_ENUM.CASE];

export const TO_STRING_FUNCTION = 'TO_STRING';

export const REGEXP_MATCH = {
  int: '(?:^[0-9]+$)',
  double: '(?:^(\\d+\\.\\d+)$)',
  string: "(?:^\\'(.*?)\\'$)",
  bool: '(?:^(true|false)$)',
};

export const EXPRESSION_TYPES = {
  STRING: 'string',
  GUID: 'guid',
  INT: 'int',
  DECIMAL: 'decimal',
  LONG: 'long',
  DOUBLE: 'double',
  FLOAT: 'float',
};

export const NUMERIC_TYPES = [
  EXPRESSION_TYPES.INT,
  EXPRESSION_TYPES.DECIMAL,
  EXPRESSION_TYPES.LONG,
  EXPRESSION_TYPES.DOUBLE,
  EXPRESSION_TYPES.FLOAT,
];
export const STRING_TYPES = [EXPRESSION_TYPES.STRING, EXPRESSION_TYPES.GUID];

export const ITERATOR_REGEX = '^[a-zA-Z_$][a-zA-Z_$0-9]*$';
export const ARITHMETICAL_OPERATOR_REGEX = '(?:[+-\\/*])';

// legacy under FT
export const OPERATORS_PRIORITY = [
  { priority: 10, regex: '(?:[\\/*])$' },
  { priority: 20, regex: '(?:[+-])$' },
  { priority: 30, regex: '(?:>=|<=|==|!=|[><]|contains|startsWith|endsWith)$' },
];

export const OPERATORS_PRIORITY_AST = [
  { priority: 30, regex: '(?:[\\/*])$' },
  { priority: 20, regex: '(?:[+-])$' },
  { priority: 10, regex: '(?:>=|<=|==|!=|[><]|contains|startsWith|endsWith)$' },
];

export const FIELD_KEYS = {
  EnumTypes: 'Enum Types',
  Timezones: 'Timezones',
};
